export default {
  title: 'Studio (V2)',
  description: 'Erstelle und verwalte die Restaurant-Website mit dem neuen Website Studio.',
  retry: 'Erneut versuchen',
  deleted: 'Projekt gelöscht.',
  errors: {
    load: 'Das Studio (V2)-Projekt konnte nicht geladen werden.',
    create: 'Das Projekt konnte nicht erstellt werden. Bitte versuche es erneut.',
    delete: 'Das Projekt konnte nicht gelöscht werden. Bitte versuche es erneut.',
  },
  EmptyState: {
    title: 'Noch kein Studio (V2)-Projekt',
    description:
      'Erstelle ein Projekt, um die Website im neuen Website Studio zu bauen. Studio (V1) bleibt unverändert.',
    description_no_access: 'Ein Onboarding-Manager kann das Projekt für diese Marke erstellen.',
    create: 'Projekt erstellen',
  },
  ProjectCard: {
    unnamed: 'Unbenanntes Projekt',
    edit: 'Im Studio bearbeiten',
    delete: 'Löschen',
    open: 'Öffnen',
    no_domain: 'Noch keine Domain',
    fields: {
      uuid: 'UUID',
      domain: 'Domain',
      websites: 'Websites',
    },
    delete_confirm: {
      title: 'Dieses Projekt löschen?',
      description: 'Das entfernt das Studio (V2)-Projekt und seine Websites. Du kannst später ein neues erstellen.',
      ok: 'Löschen',
      cancel: 'Abbrechen',
    },
  },
};
